module.exports = __webpack_public_path__ + "static/img/ohc-python.654f544.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/oneHourCode/ohc-python.jpg
// module id = 4AYE
// module chunks = 1